import { html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { PLACEMENT_TOP } from '../../common/constants/bs';
import { BaseComponent } from "../../features/base-component/base-component";

/**
 * A static element to display content in a tooltip.
 */
@customElement('mhecomm-tooltip')
export class Tooltip extends BaseComponent {
  static styles = [css`
    :host {
      display: block;
    }
  `];

  /**
   * The label of the link.
   */
  @property()
  label?: string;
 
  /**
   * The icon to use.
   */
  @property()
  icon?: string;

  /**
   * The text that appears inside of the tooltip.
   */
  @property()
  text = '';

  /**
   * The placement of the tooltip: bottom, top, left, or right.
   */
  @property()
  placement = PLACEMENT_TOP;

  renderComp() {
    return html`
      <button class="btn btn-link p-0"
         data-bs-toggle="tooltip"
         data-bs-html="true"
         title=${this.text}
         data-bs-placement=${this.placement}>
         ${this.uxtIconReady && this.icon ? html`<uxt-icon icon="${this.icon}" aria-hidden="true"></uxt-icon>` : '' }
         ${this.label ? this.label : '' }
      </button>
    `;
  }

  updated() {
    this.bsInit('[data-bs-toggle="tooltip"]', window.bootstrap?.Tooltip);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-tooltip': Tooltip;
  }
}
